import { FooterSmall } from '@app/components/organisms/footer-small';

import { BasicTemplateProps } from './basic-template.props';

export const BasicTemplate = ({ children }: BasicTemplateProps) => {
    return (
        <>
            <main>{children}</main>
            <FooterSmall />
        </>
    );
};
